import { render, staticRenderFns } from "./ColorBar.vue?vue&type=template&id=1091c83e&scoped=true"
import script from "./ColorBar.vue?vue&type=script&lang=js"
export * from "./ColorBar.vue?vue&type=script&lang=js"
import style0 from "./ColorBar.vue?vue&type=style&index=0&id=1091c83e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1091c83e",
  null
  
)

export default component.exports